import { Directive, input } from '@angular/core';

@Directive({
  selector: '[celum-square-button]',
  host: {
    class: 'celum-square-btn',
    '[class.celum-square-btn--active]': 'isActive()',
    '[class.celum-square-btn--disabled]': 'isDisabled()',
    '[class.celum-square-btn--light-ripple]': 'isRippleLight()',
    '[class.celum-square-btn--base]': "size() === 'base'",
    '[class.celum-square-btn--medium]': "size() === 'medium'",
    '[class.celum-square-btn--large]': "size() === 'large'"
  }
})
export class CelumSquareButtonDirective {
  public size = input<'base' | 'medium' | 'large'>('large');
  public isActive = input(false);
  public isDisabled = input(false);
  public isRippleLight = input(false);
}
